"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, Calendar, Users, Mail, Phone, User } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RezervirajteSubitie() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: formRef,
    isVisible: formVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="резервирайте-събитие" className="relative min-h-screen flex items-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-cover bg-center blur-sm" style={{
        backgroundImage: 'url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/restaurant_interior_ambient.png)'
      }} />
        <div className="absolute inset-0 bg-dark-background/80" />
      </div>

      <div className="container relative z-10 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${textVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`}>
            <h1 className="text-dark-foreground font-display text-[48px] leading-[1.1] tracking-tight" style={{
            transitionDelay: textVisible ? '100ms' : '0ms',
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(12px)',
            transition: 'opacity var(--duration-medium) var(--ease-smooth), transform var(--duration-medium) var(--ease-smooth)'
          }}>
              Резервирайте вашето събитие
            </h1>
            <p className="text-dark-foreground/90 text-lg leading-relaxed" style={{
            transitionDelay: textVisible ? '200ms' : '0ms',
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(12px)',
            transition: 'opacity var(--duration-medium) var(--ease-smooth), transform var(--duration-medium) var(--ease-smooth)'
          }}>
              Миш-Маш /интерпред/ предлага перфектното пространство за вашето частно или фирмено събитие. Попълнете формата и ние ще се свържем с вас за да обсъдим детайлите.
            </p>
            <div className="flex items-center gap-3 text-dark-foreground/80" style={{
            transitionDelay: textVisible ? '300ms' : '0ms',
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(12px)',
            transition: 'opacity var(--duration-medium) var(--ease-smooth), transform var(--duration-medium) var(--ease-smooth)'
          }}>
              <SafeHydrate><Calendar className="size-5 text-accent" /></SafeHydrate>
              <span className="text-sm">Гъвкави дати и пакети</span>
            </div>
            <div className="flex items-center gap-3 text-dark-foreground/80" style={{
            transitionDelay: textVisible ? '400ms' : '0ms',
            opacity: textVisible ? 1 : 0,
            transform: textVisible ? 'translateY(0)' : 'translateY(12px)',
            transition: 'opacity var(--duration-medium) var(--ease-smooth), transform var(--duration-medium) var(--ease-smooth)'
          }}>
              <Users className="size-5 text-accent" />
              <span className="text-sm">Капацитет за до 120 души</span>
            </div>
          </div>

          {}
          <div ref={formRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${formVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'}`}>
            <FormProvider className="bg-[#F0F0F0] rounded-lg p-8 shadow-clay" formId="event_booking_form_events" sectionName="резервирайте-събитие" defaultValues={{
            name: "",
            email: "",
            phone: "",
            event_date: "",
            guests: "",
            event_type: "",
            special_requests: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2,
              maxLength: 100
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              minLength: 10
            },
            event_date: {
              required: true
            },
            guests: {
              required: true,
              min: 1
            },
            event_type: {
              required: true
            },
            special_requests: {
              required: false
            }
          }} submitText="Изпратете запитване" successMessage="Благодарим! Ще се свържем с вас скоро за да потвърдим резервацията." errorMessage="Възникна грешка. Моля, опитайте отново.">
              <EventBookingForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function EventBookingForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-6 bg-secondary/10 border border-secondary/30 rounded-lg">
        <p className="text-foreground mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="w-full">
          Ново запитване
        </Button>
      </div>;
  }
  return <div className="space-y-6">
      <h2 className="text-foreground font-display text-[28px] leading-tight mb-6">
        Резервирайте събитие
      </h2>
      
      <Form onSubmit={handleSubmit}>
        <div className="space-y-5">
          <FormField control={control} name="name" rules={{
          required: "Име и фамилия е задължително",
          minLength: {
            value: 2,
            message: "Минимум 2 символа"
          },
          maxLength: {
            value: 100,
            message: "Максимум 100 символа"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Име и фамилия</FormLabel>
                <FormControl>
                  <div className="relative">
                    <User className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                    <Input placeholder="Иван Петров" className="pl-10 bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50" {...field} />
                  </div>
                </FormControl>
                <FormDescription>Въведете пълното си име.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="email" rules={{
          required: "Имейл адрес е задължителен",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Невалиден имейл адрес"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Имейл адрес</FormLabel>
                <FormControl>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                    <Input type="email" placeholder="ivan@example.com" className="pl-10 bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50" {...field} />
                  </div>
                </FormControl>
                <FormDescription>Ще изпратим потвърждение на този имейл.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone" rules={{
          required: "Телефон за контакт е задължителен",
          minLength: {
            value: 10,
            message: "Минимум 10 символа"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Телефон за контакт</FormLabel>
                <FormControl>
                  <div className="relative">
                    <Phone className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                    <Input type="tel" placeholder="+359 88 123 4567" className="pl-10 bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50" {...field} />
                  </div>
                </FormControl>
                <FormDescription>Включете кода на страната.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <div className="grid sm:grid-cols-2 gap-4">
            <FormField control={control} name="event_date" rules={{
            required: "Дата на събитието е задължителна"
          }} render={({
            field
          }) => <FormItem>
                  <FormLabel>Дата на събитието</FormLabel>
                  <FormControl>
                    <Input type="date" className="bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50" {...field} />
                  </FormControl>
                  <FormDescription>Изберете желаната дата.</FormDescription>
                  <FormMessage />
                </FormItem>} />

            <FormField control={control} name="guests" rules={{
            required: "Брой гости е задължителен",
            min: {
              value: 1,
              message: "Минимум 1 гост"
            }
          }} render={({
            field
          }) => <FormItem>
                  <FormLabel>Брой гости</FormLabel>
                  <FormControl>
                    <Input type="number" placeholder="10" min="1" className="bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50" {...field} />
                  </FormControl>
                  <FormDescription>Посочете приблизителния брой участници.</FormDescription>
                  <FormMessage />
                </FormItem>} />
          </div>

          <FormField control={control} name="event_type" rules={{
          required: "Тип събитие е задължителен"
        }} render={({
          field
        }) => <FormItem>
                <FormLabel>Тип събитие</FormLabel>
                <FormControl>
                  <select className="flex h-9 w-full min-w-0 rounded-md border border-input bg-white px-3 py-1 text-base shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm" {...field}>
                    <option value="">Изберете тип</option>
                    <option value="Частно събитие">Частно събитие</option>
                    <option value="Фирмено събитие">Фирмено събитие</option>
                    <option value="Празничен повод">Празничен повод</option>
                    <option value="Други">Други</option>
                  </select>
                </FormControl>
                <FormDescription>Изберете най-подходящата категория.</FormDescription>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="special_requests" render={({
          field
        }) => <FormItem>
                <FormLabel>Специални изисквания / бележки</FormLabel>
                <FormControl>
                  <Textarea placeholder="Например: вегетарианско меню, техническо оборудване и др." className="bg-white shadow-[inset_0_2px_4px_rgba(0,0,0,0.05)] border-border/50 min-h-24" {...field} />
                </FormControl>
                <FormDescription>Допълнителна информация, която да ни помогне да подготвим събитието.</FormDescription>
                <FormMessage />
              </FormItem>} />

          {submitError && <div className="p-4 bg-destructive/10 border border-destructive/30 rounded-lg">
              <p className="text-destructive text-sm">{submitError}</p>
            </div>}

          <Button type="submit" disabled={isSubmitting} className="w-full shadow-[inset_0_2px_4px_rgba(255,255,255,0.3),inset_0_-2px_4px_rgba(0,0,0,0.05),0_4px_8px_rgba(0,0,0,0.12)] hover:shadow-[inset_0_2px_4px_rgba(255,255,255,0.4),inset_0_-2px_4px_rgba(0,0,0,0.08),0_8px_16px_rgba(0,0,0,0.15)] transition-all duration-[var(--duration-fast)]">
            {isSubmitting ? <>
                <Loader className="animate-spin mr-2 size-4" />
                Изпращане...
              </> : 'Изпратете запитване'}
          </Button>
        </div>
      </Form>
    </div>;
}